import { ISAD_LEVELS } from "../models/isad";

const GOOD_LEVELS = new Set(["A", "B"]);
const BAD_LEVELS = new Set(["D", "E"]);

export function computeIsadDistribution(isadData) {
  const counts = Object.fromEntries(ISAD_LEVELS.map((l) => [l, 0]));
  let total = 0;
  Object.values(isadData).forEach((level) => {
    if (level && counts[level] !== undefined) {
      counts[level]++;
      total++;
    }
  });
  if (total === 0) return Object.fromEntries(ISAD_LEVELS.map((l) => [l, 0]));

  const rawPcts = Object.fromEntries(
    ISAD_LEVELS.map((l) => [l, (counts[l] / total) * 100])
  );
  const floored = Object.fromEntries(
    ISAD_LEVELS.map((l) => [l, Math.floor(rawPcts[l])])
  );
  const remainder =
    100 - ISAD_LEVELS.reduce((s, l) => s + floored[l], 0);

  const fractions = ISAD_LEVELS.map((l) => ({
    l,
    frac: rawPcts[l] - floored[l],
  })).sort((a, b) => b.frac - a.frac);

  const result = { ...floored };
  for (let i = 0; i < remainder; i++) result[fractions[i].l]++;
  return result;
}

export function deltaColor(level, delta) {
  if (delta === 0) return "neutral";
  if (GOOD_LEVELS.has(level)) return delta > 0 ? "green" : "red";
  if (BAD_LEVELS.has(level)) return delta > 0 ? "red" : "green";
  return "neutral";
}

export function formatDelta(delta) {
  if (delta === 0) return "±0%";
  return `${delta > 0 ? "+" : ""}${delta}%`;
}
